import http from '@/requests/http'

class Server {
  static findAll (params) {
    return http.post('servers/servers', params)
  }
  static store (params) {
    return http.post('servers/servers/store', params)
  }
  static view (params) {
    return http.post('servers/servers/view', params)
  }
  static update (params) {
    return http.post('servers/servers/update', params)
  }
  static destroy (params) {
    return http.post('servers/servers/destroy', params)
  }
}

export default Server
